var map = {
	"./music-instructions.json": 3063,
	"./music-library-intro2024.json": 3064,
	"./music-library-launch2024.json": 3065,
	"./music-progression.json": 3066,
	"./startSourcesAdvanced.json": 3067,
	"./startSourcesSimple.json": 3068,
	"./startSourcesSimple2.json": 3069,
	"./startSourcesTracks.json": 3070
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2850;